import { User } from '../../../website/models';

export namespace AuthActions {
  export class EnsureToken {
    static readonly type = '[Auth] Ensure Token';

    constructor(public force = false) {}
  }

  export class TokenSuccess {
    static readonly type = '[Auth] Token Success';

    constructor(
      public accessToken: string,
      public tokenType: string,
      public validUntil: number
    ) {}
  }

  export class TokenFailure {
    static readonly type = '[Auth] Token Failure';

    constructor(public error?: any) {}
  }

  export class ClearToken {
    static readonly type = '[Auth] Clear Token';
  }

  export class LoginSuccess {
    static readonly type = '[Auth] Login Success';

    constructor(public user: User) {}
  }

  export class SetUser {
    static readonly type = '[Auth] Set User';

    constructor(public user: User | null) {}
  }

  export class LogoutSuccess {
    static readonly type = '[Auth] Logout Success';
  }
}
